<template>
  <sl-page>
    <Modal
        :title="isEdit ? '编辑':'新增'"
        v-model="modal"
        @on-ok="save()"
        >
        <Form class="sm" ref="form" :model="form">
          <FormItem label="标识" prop="name">
            <Input v-model="form.name" :disabled="isEdit"></Input>
          </FormItem>
          <FormItem label="URL" prop="url">
            <Input v-model="form.url"></Input>
          </FormItem>
        </Form>
    </Modal>
    <div style="margin-bottom:15px;">
      <Button @click="create()" type="primary" icon="ios-plus-empty">添加</Button>
    </div>
    <Table :row-class-name="rowClassName" :columns="columns" :data="servers"></Table>
  </sl-page>
</template>
<script>
export default {
  data() {
    
    return {
      columns:[
        {
          title: '标识',
          key: 'name'
        },
        {
          title: 'url',
          key: 'url'
        },
        {
          title: '操作',
          key: 'action',
          width: 250,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.active(params.row)
                  }
                }
              }, '使用'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.row)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params.row)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      servers:[],
      url:'',
      form: {
        url:'' , name:''
      },
      modal:false,
      current:null,
      isEdit:false
    }
  },
  mounted(){
    let server = localStorage['server']
    try{
      let _t = JSON.parse( localStorage['servers'] )
      if(Array.isArray(_t)){
        this.servers = _t
      }
    }catch(e){

    }

    this.current = this.servers.findIndex(i=>(i.url === server))
    console.log( this.current , this.servers )

  },
  methods: {
    rowClassName(row , index){
      if(index === this.current){
        return 'active'
      }
    },
    save() {
      if(this.form.name){
        let server
        if(this.isEdit){
          let index = this.servers.findIndex(i=>(i.name == this.form.name))
          if( index >= 0){
            server = this.servers[index]

            server.url = this.form.url
            server.name = this.form.name
            if( index == this.current ){
              this.active(this.form)
            }
          }
        }else{
          server = {name:this.form.name , url : this.form.url }
          this.servers.push( server )
        }
        
        localStorage.setItem('servers' , JSON.stringify(this.servers))
      }

    },
   
    active(data){
      localStorage.setItem('server' , data.url)
      location.reload()
    },
    create(){
      this.form.name = ''
      this.form.url = ''
      this.isEdit = false
      this.modal = true
    },
    edit(data){
      this.form.name = data.name
      this.form.url = data.url
      this.isEdit = true
      this.modal = true

    },
    remove(){

    },
  }
}

</script>
<style lang="scss">
  .ivu-table .active td{
    background-color: rgba(97,175,255,0.2);
    
  }
</style>